module.exports = __webpack_public_path__ + "img/ic_kaoshi.3c37e8aa.svg";